import UseContext from "hooks/useContext";

// Dates are handled in the device's local time.
const pad = (n) => String(n).padStart(2, "0");

// The language manager keeps no language code: derive it from the loaded map.
export const useCrmLocale = () => {
  const { language } = UseContext();
  return language?.current && language.current === language.languages?.get("en")
    ? "en"
    : "fr";
};

export function startOfDay(d = new Date()) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export const sameDay = (a, b) =>
  startOfDay(a).getTime() === startOfDay(b).getTime();

export const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const monthName = (m, locale = "fr") =>
  new Intl.DateTimeFormat(locale, { month: "long" }).format(
    new Date(2026, m, 1)
  );

// Monday first: "Lu", "Ma"... (or "Mo", "Tu"...)
export const weekInitials = (locale = "fr") =>
  Array.from({ length: 7 }, (_, i) =>
    capitalize(
      new Intl.DateTimeFormat(locale, { weekday: "short" })
        .format(new Date(2026, 0, 5 + i))
        .slice(0, 2)
    )
  );

// "14 oct."
export const shortDay = (d, locale = "fr") =>
  `${d.getDate()} ${new Intl.DateTimeFormat(locale, { month: "short" }).format(
    d
  )}`;

// "Jeu. 8 oct."
export const dayLabel = (d, locale = "fr") =>
  `${capitalize(
    new Intl.DateTimeFormat(locale, { weekday: "short" }).format(d)
  )} ${shortDay(d, locale)}`;

// YYYY-MM-DD of the local day (toISOString would shift to UTC).
export const isoDay = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// YYYY-MM-DD -> local Date at noon (avoids timezone shifts)
export const fromIsoDay = (s) => {
  const [y, mo, da] = s.split("-").map(Number);
  return new Date(y, mo - 1, da, 12);
};
